import Icon from '../icon/Icon';
import './Loader.less';

export type LoaderProps = {
    title?: string;
    subtitle?: string;
};

const Loader = ({ title, subtitle }: LoaderProps) => (
    <div className={`bri-Loader`}>
        <Icon iconId="brilliant-logo" size="x-large" />
        {title && (
            <div className="bri-Loader-title bri-TitleBoldFont">{title}</div>
        )}
        {subtitle && (
            <div className="bri-TitleBoldFont bri-BodyFont">{subtitle}</div>
        )}
    </div>
);

export default Loader;
